module.exports = __webpack_public_path__ + "files/74eaf554a1f390498511c02738beb18a.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-4.png
// module id = 1479
// module chunks = 60